import React, {Component} from 'react';
import ViewRenderer from './views';
import {API} from '../../../requests';
import 'react-datasheet/lib/react-datasheet.css';
import './styles.css';
import PopupContainer from '../../../components/PopupContainer';
import POPUP_CONSTANTS from '../../../constants/popup-constants';
import Spinner from '../../../components/Spinner';
import Popup from '../../../components/SimplePopup';
import Popupcan from '../../../components/PopupPerson/popup';
import {editFormData} from './editData';
import strings from '../../../globalization';
import util from '../../../util';
import {getFormData} from './data';
import DeletePopup from '../../../components/DeletePopup';
import {commonImages, operatorImages} from '../../../assets/images';
class GateLevelRejectReason extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: undefined,
      searchText: '',
      singleGateLevelRejectReason: [],
      gateLevelRejectReason: [],
      filterGateLevelRejectReason: [],

      selectedStatus: '',
    };
  }
  statuses = [
    {
      id: '',
      name: 'ALL',
    },
    {
      id: 'inactive',
      name: 'INACTIVE',
    },
    {
      id: 'active',
      name: 'ACTIVE',
    },
  ];
  editStatusDropDown = this.statuses.filter(num => num.id !== '');
  onSubmit = gateLevelRejectReason => {
    const gateLevelRejectReasonData = {
      name: gateLevelRejectReason.name.value,
      name_hindi: gateLevelRejectReason.name_hindi.value,
      errorCode: gateLevelRejectReason.errorCode.value.toString(),
    };
    this.setState({
      popup: null,
    });
    // console.log('my gateLevelRejectReason save data', gateLevelRejectReasonData);
    this.saveGateLevelRejectReason(gateLevelRejectReasonData);
  };
  showErrorPopup = errorMsg => {
    this.setState({
      popup: {
        type: POPUP_CONSTANTS.SIMPLE_POPUP,
        message: errorMsg,
        messageStyle: {color: '#E67717'},
        headingImage: commonImages.errorIcon,
        buttons: [
          {
            text: strings.okayPopup,
            onClick: this.onClose,
          },
        ],
        onClose: this.closePopup,
      },
    });
  };
  showSuccessPopup = (successMessage, onClick) => {
    this.setState({
      popup: {
        type: POPUP_CONSTANTS.SIMPLE_POPUP,
        message: successMessage,
        onClose: this.onClose,
        headingImage: operatorImages.successIcon,
        buttons: [
          {
            text: strings.okayPopup,
            onClick: onClick ? onClick : this.onClose,
            outline: true,
          },
        ],
      },
    });
  };

  onClickHandler = (action, data) => {
    switch (action) {
      case 'edit': {
        this.setState({
          popup: {
            type: POPUP_CONSTANTS.EDIT_POPUP,
          },
          singleGateLevelRejectReason: data,
        });

        break;
      }
      case 'delete': {
        // console.log('my delete id', data);
        data.status === 'ACTIVE' &&
          this.setState({
            gateLevelRejectReason: data,
            popup: {type: POPUP_CONSTANTS.DELETE_POPUP},
          });

        break;
      }
      default: {
        break;
      }
    }
  };
  onClose = () => {
    this.setState({
      popup: null,
    });
  };
  tableActionHandler = (action, data) => {
    switch (action) {
      case 'status': {
        this.setState(
          {
            selectedStatus: data,
          },
          this.applyFilters,
        );
        break;
      }

      case 'addNewGateLevelRejectReason': {
        this.setState({
          popup: {
            type: POPUP_CONSTANTS.ADD_DATA_POPUP,
          },
        });
        break;
      }

      case 'search': {
        this.setState(
          {
            searchText: data,
          },
          this.applyFilters,
        );
        break;
      }
      case 'clearFilter': {
        this.setState({
          searchText: '',
          selectedStatus: '',
        });
        this.fetchGateLevelRejectReason();

        break;
      }
      default: {
        console.info('tableActionHandler case not handled', action);
      }
    }
  };
  onEditHandler = data => {
    let myData = {
      id: this.state.singleGateLevelRejectReason.gateLevelRejectReasonId,
      name: data.name.value,
      name_hindi: data.name_hindi.value,
      errorCode: data.errorCode.value.toString(),
      status: data.status.value.toUpperCase(),
    };
    this.setState({popup: null});
    this.updateGateLevelRejectReason(myData);
  };

  fetchGateLevelRejectReason = () => {
    this.setState({popup: {type: POPUP_CONSTANTS.SPINNER_POPUP}});
    API.fetchGateLevelRejectReasonTypeData()
      .then(res => {
        this.setState(
          {
            //...this.state,
            gateLevelRejectReason: res.data,
            filterGateLevelRejectReason: res.data,
            popup: null,
          },
          this.applyFilters,
        );
      })
      .catch(err => {
        const error = util.getErrorMessage(err);
        this.showErrorPopup(error);
      });
  };
  saveGateLevelRejectReason = gateLevelRejectReasonName => {
    let formData = {
      name: gateLevelRejectReasonName.name,
      name_hindi: gateLevelRejectReasonName.name_hindi,
      errorCode: gateLevelRejectReasonName.errorCode,
      status: gateLevelRejectReasonName.status,
    };
    API.saveGateLevelRejectReasonData(formData)
      .then(res => {
        this.showSuccessPopup(
          'Gate Level Reject Reason Added Successfully',
          this.fetchGateLevelRejectReason,
        );
      })
      .catch(error => {
        const err = util.getErrorMessage(error);
        this.showErrorPopup(err);
      });
  };
  deleteGateLevelRejectReasonData = gateLevelRejectReasonId => {
    API.deleteGateLevelRejectReason(gateLevelRejectReasonId)
      .then(res => {
        this.showSuccessPopup(
          'Gate Level Reject Reason Deleted Successfully',
          this.fetchGateLevelRejectReason,
        );
      })
      .catch(error => {
        const err = util.getErrorMessage(error);
        this.showErrorPopup(err);
      });
  };
  updateGateLevelRejectReason = data => {
    API.updatesGateLevelRejectReasonData(data)
      .then(res => {
        this.showSuccessPopup(
          'Gate Level Reject Reason Edited Successfully',
          this.fetchGateLevelRejectReason,
        );
      })
      .catch(error => {
        const err = util.getErrorMessage(error);
        this.showErrorPopup(err);
      });
  };

  getProps = () => {
    const {searchText, selectedStatus, filterGateLevelRejectReason} =
      this.state;
    return {
      onClick: this.onClickHandler,
      tableActionHandler: this.tableActionHandler,
      gateLevelRejectReason: filterGateLevelRejectReason,
      statuses: this.statuses,
      searchText,
      selectedStatus,
    };
  };

  applyFilters = () => {
    const {searchText, selectedStatus, gateLevelRejectReason} = this.state;
    const filteredData =
      gateLevelRejectReason.length > 0 &&
      gateLevelRejectReason.filter(row => {
        const name = {name: row.name, name_hindi: row.name_hindi};
        if (
          searchText &&
          !Object.values(name)
            .toString()
            .toLowerCase()
            .includes(searchText.toLowerCase())
        ) {
          return false;
        }

        if (
          selectedStatus &&
          row.status.toLowerCase() !== selectedStatus.toLowerCase()
        ) {
          return false;
        }
        return true;
      });

    console.info('filteredData', filteredData, selectedStatus);

    this.setState({
      filterGateLevelRejectReason: filteredData,
    });
  };
  getPopupContent = () => {
    const {popup} = this.state;
    switch (popup.type) {
      case POPUP_CONSTANTS.ADD_DATA_POPUP: {
        return (
          <Popupcan
            header="Add"
            onSubmit={this.onSubmit}
            onClose={this.onClose}
            getFormData={getFormData}
            // statuses={this.statuses}
          />
        );
      }
      case POPUP_CONSTANTS.EDIT_POPUP: {
        return (
          <Popupcan
            header="Edit"
            categoryTypeData={this.state.singleGateLevelRejectReason}
            onSubmit={this.onEditHandler}
            onClose={this.onClose}
            getFormData={editFormData}
            statuses={this.editStatusDropDown}
          />
        );
      }
      case POPUP_CONSTANTS.DELETE_POPUP: {
        return (
          <DeletePopup onClick={this.onDeleteHandler} onClose={this.onClose} />
        );
      }
      case POPUP_CONSTANTS.SPINNER_POPUP: {
        return <Spinner name="cube-grid" color="#0045E6" {...popup} />;
      }
      case POPUP_CONSTANTS.SIMPLE_POPUP: {
        return <Popup {...popup} />;
      }
      default: {
        console.warn('getPopupContent', popup.type);
        return null;
      }
    }
  };
  onDeleteHandler = () => {
    let gateLevelRejectReasonId =
      this.state.gateLevelRejectReason.errorCode.toString();
    //console.log('my delete id', id);
    this.setState({popup: null});
    this.deleteGateLevelRejectReasonData(gateLevelRejectReasonId);
  };
  componentDidMount() {
    this.fetchGateLevelRejectReason();
  }

  render() {
    const viewProps = this.getProps();
    const {popup} = this.state;
    return (
      <>
        {popup ? (
          <PopupContainer> {this.getPopupContent()} </PopupContainer>
        ) : null}
        <ViewRenderer {...viewProps} />
      </>
    );
  }
}
export default GateLevelRejectReason;
